export function FormatNumber(number: number, options?: any): string {
  return getFormat(number, options).format(number);
}

export function FormatMoneyNumber(number: number | undefined | null): string | null {
  if (number === null || number === undefined) {
    return null;
  }
  return getFormat(number, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(number);
}

export function FormatNumberOrNull(number: number | undefined | null, options?: any): string | null {
  if (number === null || number === undefined) {
    return null;
  }
  return getFormat(number, options).format(number);
}

export function FormatNumberWithUnitOrNull(number: number | undefined | null, unit: string, options?: any): string | null {
  if (number === null || number === undefined) {
    return null;
  }
  const adjustedOptions = getAdjustedFormatForUnit(unit, options);
  return (getFormat(number, adjustedOptions)).format(number) + " " + unit;
}

export function numberToStringForInput(n: number | undefined | null): string | undefined {
  if (n === undefined || n === null) {
    return undefined;
  }
  return n.toString().replace(".", ",");
}

export function getAdjustedFormatForUnit(unit: string, providedOptions?: any): any {
  if (providedOptions !== undefined) {
    return providedOptions;
  }
  switch (unit) {
    case 'h':
    case 'sati':
      return { minimumFractionDigits: 0, maximumFractionDigits: 1 };
    case 'km':
    case 'kilometara':
      return { minimumFractionDigits: 0, maximumFractionDigits: 0 };
    case 'l':
    case 'L':
    case 'litara':
      return { minimumFractionDigits: 0, maximumFractionDigits: 1 };
    case 'kg':
    case 'kilograma':
      return { minimumFractionDigits: 0, maximumFractionDigits: 1 };
    case 'kom':
    case 'komada':
      return { minimumFractionDigits: 0, maximumFractionDigits: 1 };
    case 'rsd':
      return { minimumFractionDigits: 2, maximumFractionDigits: 2 };
    default:
      return providedOptions;
  }
}

function getFormat(number: number, options?: any): Intl.NumberFormat {
  if (options === undefined) {
    if (Number.isInteger(number)) {
      return new Intl.NumberFormat("sr-SR");
    } else {
      return new Intl.NumberFormat("sr-SR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
  }
  return new Intl.NumberFormat("sr-SR", options);
}
